import React from 'react';
// import SubscriptionBadge from './SubscriptionBadge'; // Removed for free launch

const Header = ({ user, onSignIn, onSignOut, onBackToHome }) => (
  <div className="header">
    {/* Home Page Link - Top Left Corner */}
    {onBackToHome && (
      <div style={{
        position: 'absolute',
        top: '20px',
        left: '20px',
        zIndex: 10
      }}>
        <button
          onClick={onBackToHome}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            cursor: 'pointer',
            fontSize: '0.95rem',
            textDecoration: 'underline',
            padding: '4px 8px',
            transition: 'opacity 0.2s'
          }}
          onMouseOver={(e) => e.target.style.opacity = '0.8'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          ← Home Page
        </button>
      </div>
    )}

    <div className="header-content">
      <h1>🏠 Real Estate Returns Calculator</h1>
      <p>Calculate your true XIRR and ROI with installments, taxes, and all expenses for Indian Real Estate</p>

      {/* Authentication Section */}
      <div className="auth-container">
        {user ? (
          <div className="logged-in-view auth-section">
            <span className="user-status">
              Welcome, {user.first_name || user.name || 'User'} {user.last_name || ''}
            </span>
            {/* FREE LAUNCH: Removed SubscriptionBadge */}
            {/* <SubscriptionBadge subscription={subscription} onUpgradeClick={onUpgradeClick} /> */}
            <button onClick={onSignOut} className="auth-button">Sign Out</button>
          </div>
        ) : (
          <div className="logged-out-view auth-section">
            <button onClick={onSignIn} className="auth-button primary">Sign In</button>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default Header;